// @ngInject
export function keyboardActivation($parse: ng.IParseService): any {
  const enterKeyCode = 13;
  return (scope: ng.IScope, element: ng.IAugmentedJQuery, attr: any) => {
    let keyPressed = ($event: any) => {
      if ($event.keyCode == " ".charCodeAt(0) || $event.keyCode == enterKeyCode) {
        scope.$evalAsync(() => {
          $parse(attr.keyboardActivation)(scope);
        });
        $event.preventDefault();
      }
    };
    element.on("keypress", keyPressed);
    scope.$on("$destroy", () => {
      element.off("keypress", keyPressed);
    });
  };
}
